import {
  IMPERSONATION_BANNER_HEIGHT,
  NAVBAR_HEIGHT,
} from "../constants/layout";
import useRole from "./use-role";

/**
 * Total height (in px) reserved for the fixed Navbar, including the extra
 * "Exit Organization" strip it renders while impersonating. Sidebar and the
 * dashboard Layout both need this instead of a hardcoded 56px so their
 * marginTop/height math doesn't get covered by the taller Navbar.
 */
const useTopOffset = (): number => {
  const { isImpersonating } = useRole();
  return isImpersonating
    ? NAVBAR_HEIGHT + IMPERSONATION_BANNER_HEIGHT
    : NAVBAR_HEIGHT;
};

export default useTopOffset;
